import React, { useState } from "react";
import { format } from "date-fns";
import { useUpdateAssignmentMarkMutation } from "../../../features/assignmentMark/assignmentMarkApi";

const AssignmentMark = ({ assignmentMark }) => {
  const {
    id,
    title,
    student_id,
    assignment_id,
    student_name,
    createdAt,
    mark,
    repo_link,
  } = assignmentMark || {};
  const [markState, setMarkState] = useState(mark || 0);
  const [
    updateAssignmentMark,
    { isLoading: isAssignmentLoading, isError: isAssignmentErorr },
  ] = useUpdateAssignmentMarkMutation();

  const handleUpdateMark = () => {
    updateAssignmentMark({
      id: id,
      assignment_id: assignment_id,
      student_id: student_id,
      assignment: {
        mark: markState,
        status: "published",
      },
    });
  };

  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td">
        {format(new Date(createdAt), "dd MMM yyyy hh:mm:ss a")}
      </td>
      <td className="table-td">{student_name}</td>
      <td className="table-td">{repo_link}</td>
      {mark ? (
        <td className="table-td">{mark}</td>
      ) : (
        <td className="table-td input-mark">
          <input
            max="100"
            min="0"
            value={markState}
            type="number"
            onChange={(e) => setMarkState(Number(e.target.value))}
          />
          <svg
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400"
            onClick={handleUpdateMark}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>
        </td>
      )}
    </tr>
  );
};

export default AssignmentMark;
